export const props = { viewBox: "0 0 24 24" };
export const path = "M12 21L20 12.4645L17.8956 10.2192L13.491 14.9103L13.491 0.0916757C19.4148 0.825807 24 5.87742 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.87741 4.5852 0.825803 10.509 0.0916748L10.509 14.9103L6.1044 10.2192L4 12.4645L12 21Z";
